var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 44,
    viewBox: "0 0 152 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.37 44H5.62963C2.53474 44 0 41.5236 0 38.5V5.5C0 2.47638 2.53474 2.32537e-06 5.62963 2.32537e-06H146.37C149.465 2.32537e-06 152 2.47638 152 5.5V38.5C152 41.5236 149.465 44 146.37 44Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.37 0.881376C148.977 0.881376 151.098 2.9535 151.098 5.5V38.5C151.098 41.0465 148.977 43.1186 146.37 43.1186H5.62963C3.02311 43.1186 0.902148 41.0465 0.902148 38.5V5.5C0.902148 2.9535 3.02311 0.881376 5.62963 0.881376H146.37ZM146.37 2.32537e-06H5.62963C2.53474 2.32537e-06 0 2.47638 0 5.5V38.5C0 41.5236 2.53474 44 5.62963 44H146.37C149.465 44 152 41.5236 152 38.5V5.5C152 2.47638 149.465 2.32537e-06 146.37 2.32537e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3886 11.2679C53.3886 12.1864 53.1071 12.922 52.5526 13.4706C51.915 14.121 51.0846 14.4483 50.0671 14.4483C49.0946 14.4483 48.2642 14.1155 47.583 13.4596C46.9004 12.7941 46.5598 11.9774 46.5598 10.9998C46.5598 10.0221 46.9004 9.20539 47.583 8.5454C48.2642 7.88402 49.0946 7.55127 50.0671 7.55127C50.5512 7.55127 51.0128 7.64889 51.4534 7.83039C51.8925 8.01327 52.25 8.26077 52.5089 8.56602L51.9206 9.14627C51.4688 8.62515 50.8538 8.36802 50.0671 8.36802C49.3577 8.36802 48.7427 8.61002 48.2206 9.09814C47.704 9.58764 47.4451 10.2215 47.4451 10.9998C47.4451 11.778 47.704 12.4174 48.2206 12.9069C48.7427 13.3895 49.3577 13.637 50.0671 13.637C50.82 13.637 51.4534 13.3895 51.953 12.9014C52.2823 12.5783 52.4695 12.1328 52.5188 11.5635H50.0671V10.7688H53.3379C53.3773 10.9406 53.3886 11.107 53.3886 11.2679Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.135593,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5776 8.51251H55.5053V10.6025H58.2751V11.3973H55.5053V13.4873H58.5776V14.2971H54.6355V7.70264H58.5776V8.51251Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.135593,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2394 14.2971H61.3696V8.51251H59.4851V7.70264H64.1253V8.51251H62.2394V14.2971Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.135593,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4836 14.2971V7.70264H68.3526V14.2971H67.4836Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.135593,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2011 14.2971H71.3383V8.51251H69.4468V7.70264H74.0926V8.51251H72.2011V14.2971Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.135593,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8778 13.4486C82.2121 14.1155 81.3874 14.4483 80.4036 14.4483C79.4142 14.4483 78.5895 14.1155 77.9237 13.4486C77.2595 12.7831 76.9287 11.9664 76.9287 10.9998C76.9287 10.0331 77.2595 9.21639 77.9237 8.55089C78.5895 7.88402 79.4142 7.55127 80.4036 7.55127C81.3817 7.55127 82.2065 7.88402 82.8722 8.55639C83.5421 9.22739 83.8729 10.0386 83.8729 10.9998C83.8729 11.9664 83.5421 12.7831 82.8778 13.4486ZM78.5669 12.8959C79.068 13.3895 79.6774 13.637 80.4036 13.637C81.1242 13.637 81.7392 13.3895 82.2346 12.8959C82.7343 12.4023 82.9876 11.7684 82.9876 10.9998C82.9876 10.2311 82.7343 9.59727 82.2346 9.10365C81.7392 8.61002 81.1242 8.36252 80.4036 8.36252C79.6774 8.36252 79.068 8.61002 78.5669 9.10365C78.0673 9.59727 77.814 10.2311 77.814 10.9998C77.814 11.7684 78.0673 12.4023 78.5669 12.8959Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.135593,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0933 14.2971V7.70264H86.1488L89.4309 12.8314H89.4689L89.4309 11.5636V7.70264H90.2993V14.2971H89.3929L85.956 8.91539H85.918L85.956 10.1886V14.2971H85.0933Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.135593,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M76.715 23.9279C74.0704 23.9279 71.9101 25.8941 71.9101 28.607C71.9101 31.2979 74.0704 33.2847 76.715 33.2847C79.3651 33.2847 81.5255 31.2979 81.5255 28.607C81.5255 25.8941 79.3651 23.9279 76.715 23.9279ZM76.715 31.4422C75.2639 31.4422 74.0156 30.2721 74.0156 28.607C74.0156 26.9199 75.2639 25.7704 76.715 25.7704C78.166 25.7704 79.42 26.9199 79.42 28.607C79.42 30.2721 78.166 31.4422 76.715 31.4422ZM66.2312 23.9279C63.581 23.9279 61.4263 25.8941 61.4263 28.607C61.4263 31.2979 63.581 33.2847 66.2312 33.2847C68.8799 33.2847 71.0361 31.2979 71.0361 28.607C71.0361 25.8941 68.8799 23.9279 66.2312 23.9279ZM66.2312 31.4422C64.7787 31.4422 63.5262 30.2721 63.5262 28.607C63.5262 26.9199 64.7787 25.7704 66.2312 25.7704C67.6822 25.7704 68.9306 26.9199 68.9306 28.607C68.9306 30.2721 67.6822 31.4422 66.2312 31.4422ZM53.7559 25.362V27.3502H58.6157C58.4736 28.4612 58.0936 29.278 57.5109 29.8472C56.8016 30.5347 55.6967 31.2979 53.7559 31.2979C50.7652 31.2979 48.4233 28.9397 48.4233 26.0179C48.4233 23.096 50.7652 20.7379 53.7559 20.7379C55.373 20.7379 56.5496 21.3552 57.418 22.1555L58.8522 20.7544C57.6376 19.6214 56.0219 18.751 53.7559 18.751C49.6547 18.751 46.208 22.0111 46.208 26.0179C46.208 30.0246 49.6547 33.2847 53.7559 33.2847C55.9726 33.2847 57.6376 32.5752 58.9464 31.2442C60.2877 29.9339 60.7057 28.0914 60.7057 26.6036C60.7057 26.1416 60.6663 25.7167 60.5959 25.362H53.7559ZM104.769 26.9034C104.373 25.857 103.153 23.9279 100.668 23.9279C98.2047 23.9279 96.1541 25.824 96.1541 28.607C96.1541 31.2277 98.1835 33.2847 100.904 33.2847C103.104 33.2847 104.373 31.9744 104.895 31.2112L103.263 30.1484C102.718 30.9266 101.977 31.4422 100.904 31.4422C99.8387 31.4422 99.0744 30.9651 98.5847 30.0246L104.99 27.4355L104.769 26.9034ZM98.2384 28.4612C98.1835 26.6572 99.6726 25.7332 100.739 25.7332C101.575 25.7332 102.285 26.1416 102.521 26.726L98.2384 28.4612ZM93.0324 33.0001H95.1379V19.2501H93.0324V33.0001ZM89.5843 24.9701H89.5139C89.041 24.4229 88.1389 23.9279 86.9961 23.9279C84.5979 23.9279 82.4051 25.9849 82.4051 28.6221C82.4051 31.2442 84.5979 33.2847 86.9961 33.2847C88.1389 33.2847 89.041 32.7856 89.5139 32.2219H89.5843V32.8929C89.5843 34.6817 88.6061 35.6429 87.0284 35.6429C85.7421 35.6429 84.9441 34.7354 84.6147 33.9722L82.7837 34.7189C83.3115 35.9591 84.709 37.4854 87.0284 37.4854C89.497 37.4854 91.58 36.0664 91.58 32.6137V24.2125H89.5843V24.9701ZM87.1762 31.4422C85.7252 31.4422 84.5106 30.2556 84.5106 28.6221C84.5106 26.9735 85.7252 25.7704 87.1762 25.7704C88.6061 25.7704 89.7335 26.9735 89.7335 28.6221C89.7335 30.2556 88.6061 31.4422 87.1762 31.4422ZM114.626 19.2501H109.591V33.0001H111.69V27.7902H114.626C116.958 27.7902 119.245 26.1416 119.245 23.5195C119.245 20.8987 116.953 19.2501 114.626 19.2501ZM114.681 25.8776H111.69V21.1627H114.681C116.249 21.1627 117.144 22.4346 117.144 23.5195C117.144 24.5837 116.249 25.8776 114.681 25.8776ZM127.662 23.9017C126.144 23.9017 124.567 24.5562 123.918 26.0069L125.781 26.77C126.183 26.0069 126.92 25.7594 127.7 25.7594C128.789 25.7594 129.894 26.3987 129.911 27.5276V27.672C129.531 27.4575 128.717 27.1399 127.717 27.1399C125.71 27.1399 123.665 28.2192 123.665 30.2336C123.665 32.0761 125.308 33.2627 127.156 33.2627C128.569 33.2627 129.349 32.6399 129.839 31.9152H129.911V32.9781H131.939V27.7036C131.939 25.2657 130.075 23.9017 127.662 23.9017ZM127.408 31.4367C126.722 31.4367 125.765 31.104 125.765 30.2721C125.765 29.2079 126.958 28.7995 127.991 28.7995C128.916 28.7995 129.349 28.9989 129.911 29.2615C129.746 30.5347 128.624 31.4367 127.408 31.4367ZM139.328 24.2029L136.914 30.1635H136.842L134.347 24.2029H132.082L135.832 32.5326L133.692 37.1677H135.887L141.664 24.2029H139.328ZM120.399 33.0001H122.505V19.2501H120.399V33.0001Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7487 8.2926C11.418 8.63085 11.2266 9.15748 11.2266 9.83948V34.166C11.2266 34.848 11.418 35.3746 11.7487 35.7129L11.8303 35.7871L25.7834 22.1609V21.8391L11.8303 8.21285L11.7487 8.2926Z",
    fill: "url(#paint0_linear_4684_90803)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4295 26.7051L25.7837 22.1607V21.839L30.4352 17.2946L30.5393 17.3537L36.0479 20.4158C37.62 21.2848 37.62 22.7148 36.0479 23.5893L30.5393 26.646L30.4295 26.7051Z",
    fill: "url(#paint1_linear_4684_90803)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5393 26.6462L25.7837 22.0001L11.749 35.713C12.2712 36.2492 13.1227 36.3138 14.0909 35.7776L30.5393 26.6462Z",
    fill: "url(#paint2_linear_4684_90803)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5393 17.3539L14.0909 8.2225C13.1227 7.69175 12.2712 7.75638 11.749 8.29263L25.7837 22L30.5393 17.3539Z",
    fill: "url(#paint3_linear_4684_90803)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4684_90803",
    x1: 24.5445,
    y1: 34.4193,
    x2: 6.08888,
    y2: 15.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4684_90803",
    x1: 38.095,
    y1: 21.9983,
    x2: 10.8511,
    y2: 21.9983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4684_90803",
    x1: 27.9533,
    y1: 19.4744,
    x2: 2.92601,
    y2: -6.14282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4684_90803",
    x1: 8.21621,
    y1: 43.8062,
    x2: 19.392,
    y2: 32.3671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.d34fbc41465dff09d44b4be4dde7255c.svg";
export { ForwardRef as ReactComponent };